import { baseApi } from '@/api/core/baseApi';
import { unwrapListResponse, unwrapApiResponse } from '@/api/patterns/crud';
import type { PendingOrgRow, OnboardOrgArgs } from '../types';

export const platformPendingOrgsApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getPendingOrganizations: builder.query<PendingOrgRow[], void>({
      query: () => '/platform/pending-organizations?limit=200',
      transformResponse: unwrapListResponse<PendingOrgRow>,
      providesTags: [{ type: 'PendingOrgs', id: 'LIST' }],
    }),

    onboardOrganization: builder.mutation<unknown, OnboardOrgArgs>({
      query: ({ orgId, reason }) => ({
        url: `/platform/pending-organizations/${orgId}/onboard`,
        method: 'POST',
        body: { reason: reason ?? 'Onboarded via platform admin dashboard (Pending Orgs)' },
      }),
      transformResponse: unwrapApiResponse<unknown>,
      invalidatesTags: [
        { type: 'PendingOrgs', id: 'LIST' },
        { type: 'PlatformOrganizations', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetPendingOrganizationsQuery,
  useOnboardOrganizationMutation,
} = platformPendingOrgsApi;
